import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, map, mergeMap, Observable } from 'rxjs';
import { ChessComGame } from '../models/chess-com-game';

@Injectable({
  providedIn: 'root',
})
export class ChessComService {
  constructor(private client: HttpClient) {}

  getChessComHistoricalGames(
    userName: string,
    maxGames: number
  ): Observable<string[]> {
    const url = `https://api.chess.com/pub/player/${userName}/games/archives`;
    return this.client
      .get<{ archives: string[] }>(url)
      .pipe(map((data) => data.archives.slice(0, maxGames)));

    /*
    .pipe(
      map((data) => data.archives.slice(0, maxGames)),
      mergeMap((archives) => {
        const gameObservables = archives.map((archive) =>
          this.client.get<{ games: ChessComGame[] }>(archive)
        );
        return forkJoin(gameObservables);
      }),
      map((games) => games.flatMap((game) => game.games))
    );
    */
  }
  getChessComGames(userName: string) {
    const url = `https://api.chess.com/pub/player/${userName}/games`;
    return this.client.get(url);
  }
  getChessComGame(gameId: string) {
    const url = `https://api.chess.com/pub/game/${gameId}`;
    return this.client.get(url);
  }
}
